<template>
  <v-expansion-panel-header class="pa-5" :style="style">
    <v-layout row wrap>
      <v-flex xs6 md4>
        <div class="loadItemName">
          Load Seq:
          <span class="loadItemValue">
            {{ load.load_seq || '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="loadItemName">
          Loader Num:
          <span class="loadItemValue">
            {{ load.loader_num || '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="loadItemName">
          Trailer Num:
          <span class="loadItemValue">
            {{ load.trailer_num || '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="loadItemName">
          Receiving Hours:
          <span class="loadItemValue">
            {{ load.rec_hours || '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="loadItemName">
          Est. Qty/Loaded Date:
          <span class="loadItemValue">
            {{ load.estimated_qty_loaded_date || '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs6 md4>
        <div class="loadItemName">
          Load Count:
          <span class="loadItemValue"> {{ totals.totalLoaded }} / {{ totalPallets }} </span>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="loadItemName">
          DueDate Item:
          <span class="loadItemValue">
            {{ load.duedate_item || '-' }}
          </span>
          <span class="loadItemValue">
            {{ load.ship_to || '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="loadItemName">
          Ship To:
          <span class="loadItemValue">
            {{ load.ship_to }}
          </span>
          <span class="loadItemValue">
            {{ load.ship_to }}
          </span>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="loadItemName">
          Shipping Warehouse:
          <span class="loadItemValue">
            {{ load.shipping_warehouse }}
          </span>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="loadItemName">
          Initials:
          <span class="loadItemValue">
            {{ initials && initials.length ? initials.join(',') : '-' }}
          </span>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-spacer />
        <div class="loadItemName">
          OffLine Location:
          <span class="ml-2 loadItemValue">
            <v-select
              @click.stop=""
              v-model="load.offlineLocation1"
              :items="shippingOfflineLocations"
              style="display: inline-flex; max-width: 150px"
              itemText="name"
              itemValue="name"
              label="select"
              dense
              hide-details
              outlined
            >
              <template v-slot:append-outer>
                <v-btn
                  @click.native.stop="doAssignLocation"
                  small
                  icon
                  color="primary"
                  :disabled="load.offlineLocation1 === '' || !offlineLocationChanged"
                >
                  <v-icon>mdi-content-save-outline</v-icon>
                </v-btn>
              </template>
            </v-select>
          </span>
          <credit-hold-status
            :customer="customer"
            :sonum="sonum"
            v-if="customer && (isCreditHold || isCreditHoldCOD)"
          />
        </div>
      </v-flex>
    </v-layout>
  </v-expansion-panel-header>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CreditHoldStatus from '../load_approval/CreditHoldStatus';
import _ from 'lodash';

export default {
  name: 'LoadItemHeader',
  data() {
    return { oldOfflineLocation: null };
  },
  computed: {
    ...mapState('shippingOfflineLocation', ['shippingOfflineLocations']),
    style() {
      const { totalPallets, totals } = this;
      if (totalPallets == 0) {
        return { background: '#f17171ea' }; // red
      } else if (totalPallets === totals.totalLoaded) {
        return { background: '#95d695' }; // lt green
      } else if (totals.totalLoaded > 0 && totals.totalLoaded < totalPallets) {
        return { background: '#ffcd56' }; // orange
      }
      return {};
    },
    offlineLocationChanged() {
      return this.oldOfflineLocation != this.load.offlineLocation1;
    },
    customer() {
      if (this.load.salesOrder) return this.load.salesOrder.customer;
      return null;
    },
    sonum() {
      return parseInt(this.load.salesOrder.sonum);
    },
    isCreditHold() {
      return this.customer && this.customer.creditHold;
    },
    isCreditHoldCOD() {
      return this.customer && this.customer.creditHoldCOD;
    },
    initials() {
      return _.uniqBy(this.load.palletBreakdowns.map(pbd => pbd.initials));
    }
  },
  methods: {
    ...mapActions('shippingOfflineLocation', ['assignLoadOfflineShippingLocation']),
    doAssignLocation() {
      const { sprunnum, offlineLocation1 } = this.load;
      this.assignLoadOfflineShippingLocation({
        spRunNum: sprunnum,
        offlineLocationName: offlineLocation1
      });
      this.oldOfflineLocation = offlineLocation1;
    }
  },
  mounted() {
    this.oldOfflineLocation = this.load.offlineLocation1;
  },
  props: ['load', 'totalPallets', 'totals'],
  components: { CreditHoldStatus }
};
</script>
